import styled from "styled-components";
import { Card } from "@ann/web-components";

export const SlideoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const SlideoutHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
`;

export const SlideoutSubHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  > *:nth-child(2) {
    color: #5c5c5c;
  }
`;

export const SlideoutToolsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-right: 8px;
`;

export const SlideoutActions = styled.div`
  display: flex;
  justify-content: right;
  gap: 8px;
  padding: 16px 24px;
  margin-top: auto;
`;

export const CategoryFiltersContainer = styled.div`
  margin-top: 8px;
`;

export const ToolsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
`;

export const ToolsSectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const SeeMoreButton = styled.div`
  display: flex;
  align-items: center;
`;

export const SeeMoreLink = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #5c5c5c;

  .ann-typography {
    color: inherit !important;
  }
`;

export const ToolsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
`;

export const MostUsedGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  /* Hacer las cards más cuadradas para la vista expandida */
  > div {
    min-height: 140px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`;

export const ToolCardContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

export const ToolCardContent = styled.div`
  flex: 1;
`;

export const ToolCardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
`;

export const ToolCardDescription = styled.div`
  color: #666;
`;

export const SquareCard = styled(Card)`
  width: 100%;
  height: auto;
  min-height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;

  &:hover {
    border-color: #2173ff;
    box-shadow: 0 2px 8px rgba(33, 115, 255, 0.1);
  }
`;

export const ClickableCard = styled(Card)`
  cursor: pointer;

  &:hover {
    border-color: #2173ff;
    box-shadow: 0 2px 8px rgba(33, 115, 255, 0.1);
  }
`;

export const CardSettingsButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #666;

  &:hover {
    background: #f5f5f5;
    color: #2173ff;
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const BreadcrumbRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

export const BackLink = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  color: #2173ff;
  font-weight: 500;

  &:hover {
    color: #0056b3;
  }
`;

export const BreadcrumbText = styled.div`
  color: #666;
  font-size: 14px;
`;

export const StatusTag = styled.div`
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  margin-top: 8px;
  background: ${(props) => (props.setupNeeded ? "#FFF3E0" : "#E3F2FD")};
  color: ${(props) => (props.setupNeeded ? "#E65100" : "#1976D2")};
`;

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
